import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)
export const i18n = new VueI18n({
    locale: 'it',
    fallbackLocale: 'it',
    messages: {
        it: { hello: 'Ciao',
              home: {
                title: 'Inizia subito a giocare a Briscola Chiamata!',
                username: 'Inserisci un nickname:',
                play: 'Gioca',
                change: 'Cambia utente',
                caption: 'Gioca con altri utenti on-line o invita i tuoi amici! Briscolachiamata.online è gratis e senza registrazione.'
              },
              waiting: {
                addbot: 'AGGIUNGI ROBOTTINO',
                leave: 'LASCIA IL TAVOLO'
              }
            },
        en: { hello: 'Hello'},
    }
})